import styled from 'styled-components'
import { Button } from '@dsny/dsny-component-library'
import { BREAKPOINT_QUERIES } from 'styles/breakpoints'

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    gap: 24px;
  }
`

export const CopyBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    gap: 8px;
  }
`

export const ModalHeader = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column-reverse;
  gap: 4px;
  width: 100%;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    align-items: center;
    flex-direction: row;
    gap: 16px;
  }
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  color: ${({ theme }) => theme.colors.neutralW90};
  background: transparent;
  border: 0;
  flex: 0 0 auto;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.player50};
    outline-offset: 2px;
  }

  svg {
    width: 14px;
    height: 14px;
    flex: 0 0 auto;
  }
`

export const Title = styled.h2`
  width: 100%;
  margin: 0;
  color: ${({ theme }) => theme.colors.neutralW90};
  font-family: ${({ theme }) => theme.fonts?.primary || 'Nunito Sans'};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    flex: 1;
    min-width: 0;
    font-size: 20px;
  }
`

export const BodyText = styled.p`
  width: 100%;
  margin: 0;
  color: ${({ theme, $hasError }) =>
    $hasError ? theme.colors.error70 : theme.colors.neutralW70};
  font-family: ${({ theme }) => theme.fonts?.primary || 'Nunito Sans'};
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  overflow-wrap: anywhere;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    font-size: 14px;
    line-height: 20px;
  }
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media ${BREAKPOINT_QUERIES.tabletUp} {
    flex-direction: row;
    justify-content: flex-end;
  }
`

export const ActionButton = styled(Button)`
  && {
    width: 100%;
    height: 36px;
    min-height: 36px;
    padding: 6px 16px;
    font-size: 14px;
    line-height: 20px;

    @media ${BREAKPOINT_QUERIES.tabletUp} {
      width: auto;
    }
  }
`
